/* Component Dependencies */
var messageContentTemplate = require('templates/messageContent.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
AriesComponent.create({
  type: 'messageContent',
  template: {
    'messageContent': messageContentTemplate
  }
});
